import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import Seo from "../../../components/common/Seo";
import Hero from "../../../layouts/user/_components/Hero";
import WebLayout from "../../../layouts/web";
import Footer from "../../../layouts/web/_components/footer";
import Platform from "../../../layouts/web/_components/platform";
import CheckoutDetails from "./_components/CheckoutDetails";

export default function Checkout() {
  const location = useLocation();
  const courseId = location?.state?.courseId;
  const navigate = useNavigate();

  const breadcrumb = [
    {
      title: "কোর্স",
      path: "/courses",
    },
    {
      title: "বিস্তারিত",
      path: `/courses/${courseId}`,
    },
    {
      title: "চেকআউট",
    },
  ];

  useEffect(() => {
    if (!courseId) {
      navigate("/");
    }
  }, [courseId, navigate]);

  return (
    <WebLayout>
      <Seo title="Checkout - manPowerX" />
      <Hero title="Checkout" breadcrumb={breadcrumb} />
      <CheckoutDetails />
      <Platform />
      <Footer isPlatform={true} />
    </WebLayout>
  );
}
